import { globalState } from '@codeleap/store'
import { CommunityComment } from '@/types'

type storeType = {
  replyTo?: CommunityComment
}

const store = globalState<storeType>({ replyTo: null })

export function setReplyTo(comment: CommunityComment | null) {
  store.set({ replyTo: comment })
}

export function getReplyTo() {
  return store.get().replyTo
}

export function resetReplyState() {
  store.reset({ replyTo: null })
}

export function use() {
  return store.use()
}
